import { render } from "./cart-summary.vue?vue&type=template&id=55bab53a"
import script from "./cart-summary.vue?vue&type=script&lang=js"
export * from "./cart-summary.vue?vue&type=script&lang=js"

import "./cart-summary.vue?vue&type=style&index=0&id=55bab53a&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__